import React from 'react';
import './CISViewModal.scss';
// import { CSVLink } from 'react-csv';
// import { deleteEventCisDataRow } from '../../helper/helper';
// import DefaultTable from '../../components/ui/Table/Table';
import DashboardTable from '../../components/AdminDashboard/DashboardTable';
// import CustomButton from '../../components/ui/Button/Button';

const CISViewModal = ({ modalIsOpen, closeModal, eventinfoforCis, cisdata }) => {
  // const [arrIds, setArrIds] = useState([]);
  const combinedString = `${eventinfoforCis.id} ${eventinfoforCis.date}`;
  const result = cisdata[combinedString];

  // const columns = [
  //   /* { field: '_id', headerName: 'Id', width: 50 }, */
  //   { field: 'saleInvoice', headerName: 'Sales Invoice', width: 130 },
  //   { field: 'tenderedDate', headerName: 'Tendered Date', width: 130 },
  //   { field: 'user', headerName: 'User', width: 200 },
  //   { field: 'specialistId', headerName: 'Specialist ID', width: 100 },
  //   {
  //     field: 'manuallyUploadedBy',
  //     headerName: 'Manually Uploaded',
  //     valueGetter: (params) => (params.row.manuallyUploadedBy ? 'Yes' : 'No'),
  //   },
  //   { field: 'customerName', headerName: 'Customer Name', width: 200 },
  //   { field: 'email', headerName: 'Email', width: 250 },
  //   { field: 'accountNum', headerName: 'Account Number', width: 200 },
  //   { field: 'deposit', headerName: 'Deposit', width: 100 },
  //   { field: 'retailPrice', headerName: 'Retail Price', width: 100 },
  //   { field: 'phoneProtectionPlan', headerName: 'PPP', width: 100 },
  //   { field: 'activatedPromotion', headerName: 'Promo', width: 400 },
  //   { field: 'phoneNum', headerName: 'Phone Number', width: 150 },
  //   { field: 'tempPhoneNum', headerName: 'Temporary Number', width: 150 },
  //   { field: 'simNumber', headerName: 'SIM Number', width: 200 },
  //   { field: 'imei', headerName: 'IMEI', width: 200 },
  //   { field: 'amountYouPaid', headerName: 'Amount Paid', width: 150 },
  //   { field: 'connectionType', headerName: 'Connection Type', width: 100 },
  //   { field: 'activationDate', headerName: 'Activation Date', width: 200 },
  //   { field: 'phoneMake', headerName: 'Phone Make', width: 400 },
  //   { field: 'planName', headerName: 'Plan Name', width: 400 },
  //   { field: 'planPrice', headerName: 'Plan Price', width: 100 },
  //   { field: 'myBalanceOwing', headerName: 'Balance Owing', width: 100 },
  //   { field: 'oneTimeCharges', headerName: 'One Time Charge', width: 100 },
  //   { field: 'addons', headerName: 'Add-Ons', width: 700 },
  //   { field: 'autoPayPre', headerName: 'Auto Pay Pre', width: 150 },
  //   { field: 'autoPayPost', headerName: 'Auto Pay Post', width: 150 },
  //   { field: 'storeId', headerName: 'Store ID', width: 100 },
  //   { field: 'eventName', headerName: 'Event Name', width: 300 },
  //   { field: 'eventDate', headerName: 'Event Date', width: 300 },
  // ];

  const rows = result?.map((row) => ({
    _id: row._id,
    saleInvoice: row.saleInvoice,
    tenderedDate: row.tenderedDate,
    customerName: row.customerName,
    email: row.email,
    accountNum: row.accountNum,
    deposit: row.deposit,
    retailPrice: row.retailPrice,
    phoneProtectionPlan: row.phoneProtectionPlan,
    activatedPromotion: row.activatedPromotion,
    phoneNum: row.phoneNum,
    tempPhoneNum: row.tempPhoneNum,
    simNumber: row.simNumber,
    imei: row.imei,
    amountYouPaid: row.amountYouPaid,
    connectionType: row.connectionType,
    activationDate: row.activationDate,
    phoneMake: row.phoneMake,
    planName: row.planName,
    planPrice: row.planPrice,
    myBalanceOwing: row.myBalanceOwing,
    oneTimeCharges: row.oneTimeCharges,
    addons: row.addons,
    autoPayPre: row.autoPayPre,
    autoPayPost: row.autoPayPost,
    specialistId: row.specialistId,
    storeId: row.storeId,
    user: row.user,
    eventName: row.eventName,
    eventDate: row.eventDate,
    manuallyUploadedBy: row.manuallyUploadedBy,
  }));

  // async function deleteCisData(id) {
  //   let saleInvoice = null;
  //   id.forEach((singleId) => {
  //     const cis = result.find((cis) => cis._id === singleId);
  //     if (cis) {
  //       saleInvoice = saleInvoice ? `${saleInvoice}, ${cis.saleInvoice}` : cis.saleInvoice;
  //     }
  //   });

  //   await deleteEventCisDataRow({ id, saleInvoice });
  // }

  // useEffect(() => {
  //   if (!modalIsOpen) {
  //     setArrIds([]); // Reset arrIds when the modal is closed
  //   }
  // }, [modalIsOpen]);

  return (
    modalIsOpen && (
      <div className="cvm-modal">
        <div className="modal-content-view-modal">
          <div className="close-button">
            <button onClick={closeModal}>✖</button>
          </div>
          <div className="tablecontainer">
            <div className="bottomtable" style={{ height: 530, width: '100%' }}>
              {/* <DefaultTable
              rows={rows ? rows : []}
              columns={columns}
              onRowSelectionChange={(ids) => {
                setArrIds(ids);
              }}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 5 },
                },
              }}
              checkboxSelection
              disableRowSelectionOnClick
              deleteBtnProps={{
                onClick: () => deleteCisData(arrIds),
                disabled: arrIds.length === 0,
                msg: `Are you sure you want to delete the data <b>${arrIds
                  .map((id) => {
                    const cis = result.find((cis) => cis._id === id);
                    return cis ? cis.saleInvoice : '';
                  })
                  .filter((invoice) => invoice)
                  .join(', ')}?</b>`,
              }}
              csvFileName="EventCIS"
            /> */}
            {/* Using Dashboard Table */}
              <DashboardTable
                employeeData={rows}
                eventinfoforCis={eventinfoforCis}
                pageSizeOptions={[5,10,15]}
              />
            </div>
            {/* <div className="topbuttons">
            <CSVLink data={result ? result : ''}>
              <CustomButton buttonType="download" />
            </CSVLink>
          </div> */}
          </div>
        </div>
      </div>
    )
  );
};

export default CISViewModal;
